import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 14,
    backgroundColor: 'rgba(245, 245, 247, 0.8)',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.06)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.10)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1.5,
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: theme.palette.primary.main,
    },
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    fontSize: '0.75rem',
  },
}));

export const CustomTextField = ({
  variant = 'outlined',
  startIcon,
  endIcon,
  errorMessage,
  error,
  helperText,
  ...props
}) => {
  const inputProps = {
    startAdornment: startIcon ? (
      <InputAdornment position="start">{startIcon}</InputAdornment>
    ) : undefined,
    endAdornment: endIcon ? (
      <InputAdornment position="end">{endIcon}</InputAdornment>
    ) : undefined,
  };

  // Extract custom props to prevent them from being passed to DOM
  const { errorMessage: _, ...domProps } = props;

  return (
    <StyledTextField
      variant={variant}
      InputProps={inputProps}
      error={error || !!errorMessage}
      helperText={errorMessage || helperText}
      {...domProps}
    />
  );
};
